import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography 
} from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const LinkedInConnectDialog = ({ open, onClose, onConnect }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ textAlign: 'center' }}>
        Connect LinkedIn Account
      </DialogTitle>
      <DialogContent>
        <Typography 
          variant="body1" 
          sx={{ 
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            py: 2
          }}
        >
          <LinkedInIcon sx={{ fontSize: 48, color: '#0A66C2' }} />
          To share posts on LinkedIn, you need to connect your LinkedIn account first.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button 
          onClick={onConnect} 
          variant="contained" 
          sx={{ 
            bgcolor: '#0A66C2',
            '&:hover': { bgcolor: '#004182' }
          }}
        >
          Connect LinkedIn
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LinkedInConnectDialog; 